<div *ngIf="!modalData.isEdit" [formGroup]="ratingForm" class="mt-1">
  <div class="form-group row">
    <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
    <div class="col-10">
      <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off"
        ngDefaultControl>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-3 col-form-label">จำนวนระดับ<lifedi-require></lifedi-require></label>
    <div class="col-3">
      <select class="custom-select form-control" formControlName="length" style="display: inline;"
        (change)="addLength()">
        <option *ngFor="let lv of ratingLength" [value]="lv">{{ lv }}</option>
      </select>
    </div>
    <!-- <label class="col-3 col-form-label">ค่าเริ่มต้นที่<lifedi-require></lifedi-require></label>
    <div class="col-3">
      <select formControlName="default" class="custom-select form-control" style="display: inline;">
        <option value="0">0</option>
        <option value="1">1</option>
      </select>
    </div> -->
  </div>

  <div *ngIf="ratingForm.value.length">
    <div *ngFor="let lv of ratingFormArray.controls; let i = index" formArrayName="choices">
      <div [formGroupName]="i" class="form-group row">
        <label class="offset-1 col-1 col-form-label">
          {{ ratingForm.value.length > 7 ? i === 0 ? 'min' : 'max' : i+1 }}
        </label>
        <input class="form-control col-9" formControlName="choice_detail" type="text">
      </div>
    </div>
  </div>
</div>

<div *ngIf="modalData.isEdit" [formGroup]="ratingForm" class="mt-1">
  <div class="form-group row">
    <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
    <div class="col-10">
      <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off"
        ngDefaultControl>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-3 col-form-label">จำนวนระดับ<lifedi-require></lifedi-require></label>
    <div class="col-3">
      <select class="custom-select form-control" formControlName="length" style="display: inline;"
        (change)="addLength()">
        <option *ngFor="let lv of ratingLength" [value]="lv">{{ lv }}</option>
      </select>
    </div>
    <!-- <label class="col-3 col-form-label">ค่าเริ่มต้นที่<lifedi-require></lifedi-require></label>
    <div class="col-3">
      <select formControlName="default" class="custom-select form-control" style="display: inline;">
        <option value="0">0</option>
        <option value="1">1</option>
      </select>
    </div> -->
  </div>

  <div *ngIf="ratingForm.value.length">
    <div *ngFor="let lv of ratingFormArray.controls; let i = index" formArrayName="choices">
      <div [formGroupName]="i" class="form-group row">
        <label class="offset-1 col-1 col-form-label">
          {{ ratingForm.value.length > 7 ? i === 0 ? 'min' : 'max' : i+1 }}
        </label>
        <input class="form-control col-9" formControlName="choice_detail" type="text">
      </div>
    </div>
  </div>
</div>
